import {
  Box,
  Button,
  Container,
  Rating,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useGetAllCommentsQuery } from "../../../../Store/Slices/CommentsSlice/CommentsApi";
import AddCommentModal from "./AddCommentModal";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import moment from "moment-jalaali";

export default function ProductDetailsComment({ prCode = "", varCode = "" }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [count, setCount] = useState(2);
  const [openModal, setOpenModal] = useState(false);
  const { token } = useSelector((state) => state.userSlice);

  const { data, isFetching, refetch } = useGetAllCommentsQuery(
    `comments?product_code=${prCode}&variant_code=${varCode}&page=1&no_of_docs_each_page=10`,
  );
  // data?.data
  const comments = data?.data?.map((e, index) => {
    return (
      <Stack
        key={index}
        sx={{
          py: ".8rem",
          px: "1rem",
          direction: "rtl",
          position: "relative",
          width: "100%",
        }}
      >
        {/* <Rating sx={{ direction: "ltr" }} value={3} readOnly={true} /> */}
        <Stack
          direction={"row"}
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: theme.palette.primary.main,
            }}
          >
            {e?.name}
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              color: theme.palette.text.lowOpacity,
            }}
          >
            {moment?.unix(e?.created_at)?.format("jYYYY/jMM/jDD")}
          </Typography>
        </Stack>
        <Typography sx={{ my: "14px", px: "1rem" }}>{e?.content}</Typography>
        {e?.answer && (
          <Typography sx={{ my: "14px", px: "1rem" }}>
            پاسخ ادمین : {e?.answer}
          </Typography>
        )}
        <GradientBorderBox borderSize=".1rem" radius=".5rem" />
      </Stack>
    );
  });
  return (
    <Stack
      sx={{
        mt: "5rem",
        px: { xs: "24px", sm: "24px", md: "90px" },
        zIndex: "100",
      }}
    >
      <AddCommentModal
        prCode={prCode}
        varCode={varCode}
        setOpen={setOpenModal}
        open={openModal}
      />
      <Stack
        direction={"row"}
        sx={{
          gap: "24px",
          mx: "auto",
          maxWidth: "1440px",
          width: "100%",
          mb: "2rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            color: theme.palette.primary.main,
            fontWeight: "500",
            fontSize: "1.3rem",
            alignItems: "center",
            display: "flex",
          }}
        >
          نظرات شما
        </Box>
        <BorderedButton
          onclick={() => {
            if (token) {
              setOpenModal(true);
            } else {
              navigate("/auth");
            }
          }}
          sx={{
            width: "200px",
            borderRadius: "10px",

            color: theme.palette.primary.main,
          }}
        >
          ثبت نظر
        </BorderedButton>
      </Stack>
      <Container
        maxWidth={"xl"}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          width: "100%",
          alignItems: "center",
        }}
      >
        {comments?.length != 0 ? (
          comments
        ) : (
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.primary.main,
              py: "24px",
            }}
          >
            هنوز نظری ثبت نشده است!
          </Typography>
        )}
      </Container>
      {/* Modal */}
      {/* <Stack sx={{ direction: "rtl" }}>
        {comments?.slice(0, count)}
        <Button
          onClick={() => setCount(count + 5)}
          sx={{
            width: "250px",
            mx: "auto",
            my: "32px",
            borderRadius: "10px",
            border: `2px solid ${theme.palette.primary.main}`,
            // boxShadow: ` 0px 0px 9.7px 2px #00009673`,
            bgcolor: theme.palette.background.default,
            color: theme.palette.secondary.main,
          }}
        >
          مشاهده همه
          مشاهده بیشتر
        </Button>
      </Stack> */}
    </Stack>
  );
}
